module.exports = __webpack_public_path__ + "static/media/32_B.4d7db73d.png";